/*
 * Copyright 2015-2023 Ritense BV, the Netherlands.
 *
 * Licensed under EUPL, Version 1.2 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '@valtimo/shared';
import { Observable } from 'rxjs';
import { ActionDefinitionEntry } from '../models';
import { DocumentDefinition } from '@valtimo/document';

@Injectable({
  providedIn: 'root',
})
export class TezzaPluginService {
  private valtimoEndpointUri: string;

  constructor(private http: HttpClient, configService: ConfigService) {
    this.valtimoEndpointUri = configService.config?.valtimoApi?.endpointUri;
  }

  getAllActionDefinitions(): Observable<ActionDefinitionEntry[]> {
    return this.http.get<ActionDefinitionEntry[]>(
      `${this.valtimoEndpointUri}v1/tezza/action-definitions`
    );
  }

  getAllDocumentDefinitions(): Observable<DocumentDefinition[]> {
    return this.http.get<DocumentDefinition[]>(
      `${this.valtimoEndpointUri}v1/tezza/document-definition`
    );
  }
}
